var _g, _path, _path2, _g2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 84,
    viewBox: "0 0 64 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 75.9996H56C56 74.5996 56 71.9996 56 67.9996C56 58.9996 50 53.1996 50 53.1996C50 53.1996 44 47.5996 42.2 45.7996C40.4 43.9996 42.2 42.1996 42.2 42.1996C42.2 42.1996 44.8 39.5996 50.6 34.1996C56.2 28.7996 56 20.7996 56 20.7996V10.5996L32 8.59961L8 10.5996V20.7996C8 20.7996 7.8 28.5996 13.4 34.1996C19 39.5996 21.8 42.1996 21.8 42.1996C21.8 42.1996 23.6 43.9996 21.8 45.7996C20 47.5996 14 53.1996 14 53.1996C14 53.1996 8 58.7996 8 67.9996C8 71.9996 8 74.5996 8 75.9996H4C1.8 75.9996 0 77.7996 0 79.9996C0 82.1996 1.8 83.9996 4 83.9996H60C62.2 83.9996 64 82.1996 64 79.9996C64 77.7996 62.2 75.9996 60 75.9996Z",
    fill: "#231F20"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0009 49.1996C50.0009 49.1996 44.0009 43.5996 42.2009 41.7996C40.4009 39.9996 42.2009 38.1996 42.2009 38.1996C42.2009 38.1996 44.8009 35.5996 50.6009 30.1996C56.2009 24.7996 56.0009 16.7996 56.0009 16.7996V6.59961L32.0009 4.59961L8.00089 6.59961V16.7996C8.00089 16.7996 7.80089 24.5996 13.4009 30.1996C19.0009 35.5996 21.8009 38.1996 21.8009 38.1996C21.8009 38.1996 23.6009 39.9996 21.8009 41.7996C20.0009 43.5996 14.0009 49.1996 14.0009 49.1996C14.0009 49.1996 8.00089 54.7996 8.00089 63.9996C8.00089 72.9996 8.00089 74.1996 8.00089 74.1996H32.0009H56.0009C56.0009 74.1996 56.0009 73.1996 56.0009 63.9996C56.0009 54.9996 50.0009 49.1996 50.0009 49.1996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61.9992V39.9992C30 35.7992 28 33.1992 27.4 32.5992L19 24.5992C16 21.7992 16 17.1992 16 17.1992H32H48C48 17.1992 48 21.7992 45 24.5992L36.6 32.5992C35.8 33.1992 34 35.7992 34 39.9992V61.9992H30Z",
    fill: "#566FFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 8C64 10.2 62.2 12 60 12H4C1.8 12 0 10.2 0 8C0 5.8 1.8 4 4 4H60C62.2 4 64 5.8 64 8Z",
    fill: "#231F20"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 4C64 6.2 62.2 8 60 8H4C1.8 8 0 6.2 0 4C0 1.8 1.8 0 4 0H60C62.2 0 64 1.8 64 4Z",
    fill: "#F5CF87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76C64 78.2 62.2 80 60 80H4C1.8 80 0 78.2 0 76C0 73.8 1.8 72 4 72H60C62.2 72 64 73.8 64 76Z",
    fill: "#F5CF87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72H14L32 56L50 72Z",
    fill: "#566FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.a198c5d479a4e163953451f92185d734.svg";
export { ForwardRef as ReactComponent };